// READ ALL AUDITS
export const useDummyAccountAudits = false;
export const dummyAccountAudits = {
    paging: {
        current_page: 1,
        per_page: 10,
        total: 2,
    },
    records: [
        {
            id: 2,
            user_id: 1,
            user_first_name: "yichang",
            action: "UPDATED",
            created_at: "2024-02-23 07:48:53",
        },
        {
            id: 1,
            user_id: 1,
            user_first_name: "yichang",
            action: "CREATED",
            created_at: "2024-02-07 18:38:15",
        },
    ],

};

// READ SINGLE AUDIT
export const useDummyAccountAudit = false;
export const dummyAccountAudit = {
    record: {
        id: 1,
        user_id: 1,
        account_id: 21,
        action: "UPDATED",
        compare_data: {
            id: 21,
            code: "5001",
            name: "Disney Dis knee Discount",
            description: null,
            currency_code: "USD",
            currency: {
                code: "USD",
                symbol: "$",
                name: "US Dollar",
            },
            balance: null,
            type: "income",
            parent_id: null,
            // parent_name: 'Cash Desposit', // <---- NEW FIELD
            parent_name: null, // <---- NEW FIELD
            system_type: "discount_given",
            classification: null,
            is_locked: true,
            is_archived: false,
            stock_opening_account_id: null,
            stock_closing_account_id: null,
        },
        current_data: {
            id: 21,
            code: "5001",
            name: "Discount Given",
            description: null,
            currency_code: "MYR",
            currency: {
                code: "MYR",
                symbol: "RM",
                name: "Malaysian Ringgit",
            },
            balance: null,
            type: "income",
            parent_id: null,
            parent_name: 'Bank & Cash Accounts', // <---- NEW FIELD
            system_type: "discount_given",
            classification: null,
            is_locked: true,
            is_archived: false,
            stock_opening_account_id: null,
            stock_closing_account_id: null,
        },
        created_at: "2024-02-23 12:52:24",
    },
};
